import { render, staticRenderFns } from "./nfc.vue?vue&type=template&id=2683fc8e&scoped=true&"
import script from "./nfc.vue?vue&type=script&lang=js&"
export * from "./nfc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2683fc8e",
  null
  
)

export default component.exports